import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const CookiePolicy: React.FC = () => {
  return (
    <div>
      <section className="relative pt-32 pb-12 bg-gradient-hero text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-60 h-60 bg-secondary rounded-full blur-3xl" />
        </div>
        <div className="container mx-auto relative z-10">
          <motion.div 
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-5xl font-extrabold mb-6 font-display">Cookie Policy</h1>
            <p className="text-xl text-white/80">
              Ai sensi dell'art. 122 del D.Lgs. 196/2003 e del Provvedimento del Garante n. 229/2014
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto">
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-2xl shadow-card border border-light-border/50"
          >
            <div className="prose prose-lg max-w-none prose-headings:font-display prose-headings:text-light-text prose-p:text-light-muted prose-li:text-light-muted prose-a:text-primary">
              <p className="text-sm text-light-muted italic">
                Ultimo aggiornamento: Gennaio 2026
              </p>

              <h2>Informativa sull'utilizzo dei Cookie</h2>
              <p>
                La presente Cookie Policy descrive i cookie e le tecnologie similari utilizzati sul sito web 
                rinovagroup.it, gestito da Rinova Srl (P.IVA IT03994100794), e le modalità per gestirli.
              </p>

              <h3>1. Cosa Sono i Cookie</h3>
              <p>
                I cookie sono piccoli file di testo che vengono memorizzati sul dispositivo dell'utente (computer, 
                tablet, smartphone) quando visita un sito web. I cookie sono ampiamente utilizzati per far funzionare 
                i siti web in modo più efficiente, per migliorare l'esperienza dell'utente e per fornire informazioni 
                ai gestori del sito.
              </p>
              <p>
                I cookie possono essere "di sessione" (cancellati alla chiusura del browser) o "persistenti" 
                (memorizzati fino alla scadenza o alla cancellazione da parte dell'utente). Possono essere "di prima parte" 
                (impostati dal sito visitato) o "di terza parte" (impostati da un dominio diverso).
              </p>

              <h3>2. Tipologie di Cookie Utilizzati</h3>

              <h4>2.1 Cookie Tecnici / Necessari (non richiedono consenso)</h4>
              <p>
                Questi cookie sono essenziali per il corretto funzionamento del sito web. Senza questi cookie, 
                il sito non potrebbe funzionare correttamente. Non possono essere disattivati nei nostri sistemi.
              </p>
              <table className="min-w-full border text-sm">
                <thead>
                  <tr className="bg-light-background">
                    <th className="border p-2 text-left">Nome Cookie</th>
                    <th className="border p-2 text-left">Scopo</th>
                    <th className="border p-2 text-left">Durata</th>
                    <th className="border p-2 text-left">Tipo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border p-2">cookieConsent</td>
                    <td className="border p-2">Memorizza le preferenze dell'utente relative ai cookie</td>
                    <td className="border p-2">12 mesi</td>
                    <td className="border p-2">Prima parte</td>
                  </tr>
                  <tr>
                    <td className="border p-2">PHPSESSID</td>
                    <td className="border p-2">Mantiene la sessione dell'utente attiva durante la navigazione</td>
                    <td className="border p-2">Sessione</td>
                    <td className="border p-2">Prima parte</td>
                  </tr>
                </tbody>
              </table>

              <h4>2.2 Cookie Analitici / di Prestazione (richiedono consenso)</h4>
              <p>
                Questi cookie raccolgono informazioni aggregate e anonime sull'utilizzo del sito, permettendoci 
                di comprendere come i visitatori interagiscono con il sito e di migliorarne le prestazioni.
              </p>
              <table className="min-w-full border text-sm">
                <thead>
                  <tr className="bg-light-background">
                    <th className="border p-2 text-left">Nome Cookie</th>
                    <th className="border p-2 text-left">Scopo</th>
                    <th className="border p-2 text-left">Durata</th>
                    <th className="border p-2 text-left">Fornitore</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border p-2">_ga</td>
                    <td className="border p-2">Registra un ID univoco per generare dati statistici sulla navigazione</td>
                    <td className="border p-2">24 mesi</td>
                    <td className="border p-2">Google Analytics</td>
                  </tr>
                  <tr>
                    <td className="border p-2">_ga_*</td>
                    <td className="border p-2">Utilizzato da Google Analytics 4 per mantenere lo stato della sessione</td>
                    <td className="border p-2">24 mesi</td>
                    <td className="border p-2">Google Analytics</td>
                  </tr>
                  <tr>
                    <td className="border p-2">_gid</td>
                    <td className="border p-2">Registra un ID univoco per dati statistici su base giornaliera</td>
                    <td className="border p-2">24 ore</td>
                    <td className="border p-2">Google Analytics</td>
                  </tr>
                  <tr>
                    <td className="border p-2">_gat</td>
                    <td className="border p-2">Limita la frequenza delle richieste verso Google Analytics</td>
                    <td className="border p-2">1 minuto</td>
                    <td className="border p-2">Google Analytics</td>
                  </tr>
                </tbody>
              </table>

              <h4>2.3 Cookie di Marketing / Profilazione (richiedono consenso)</h4>
              <p>
                Questi cookie possono essere impostati attraverso il nostro sito da partner pubblicitari. 
                Vengono utilizzati per costruire un profilo dei tuoi interessi e mostrarti annunci pertinenti 
                su altri siti. Non memorizzano direttamente dati personali ma si basano sull'identificazione 
                univoca del browser e del dispositivo.
              </p>
              <table className="min-w-full border text-sm">
                <thead>
                  <tr className="bg-light-background">
                    <th className="border p-2 text-left">Nome Cookie</th>
                    <th className="border p-2 text-left">Scopo</th>
                    <th className="border p-2 text-left">Durata</th>
                    <th className="border p-2 text-left">Fornitore</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border p-2">_gcl_au</td>
                    <td className="border p-2">Utilizzato da Google Ads per il monitoraggio delle conversioni</td>
                    <td className="border p-2">3 mesi</td>
                    <td className="border p-2">Google Ads</td>
                  </tr>
                  <tr>
                    <td className="border p-2">_fbp</td>
                    <td className="border p-2">Utilizzato da Meta/Facebook per la visualizzazione di annunci</td>
                    <td className="border p-2">3 mesi</td>
                    <td className="border p-2">Meta Platforms</td>
                  </tr>
                </tbody>
              </table>

              <h3>3. Gestione delle Preferenze sui Cookie</h3>
              <p>L'utente può gestire le proprie preferenze sui cookie in diversi modi:</p>
              <ul>
                <li>
                  <strong>Banner dei cookie:</strong> Al primo accesso al sito, viene mostrato un banner che consente 
                  di accettare o rifiutare i cookie non tecnici. L'utente può modificare le proprie preferenze in qualsiasi momento.
                </li>
                <li>
                  <strong>Impostazioni del browser:</strong> La maggior parte dei browser consente di gestire i cookie. 
                  Di seguito i link alle istruzioni dei principali browser:
                  <ul>
                    <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
                    <li><a href="https://support.mozilla.org/it/kb/protezione-antitracciamento-avanzata-firefox-desktop" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
                    <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Apple Safari</a></li>
                    <li><a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
                  </ul>
                </li>
                <li>
                  <strong>Opt-out specifici:</strong>
                  <ul>
                    <li>Google Analytics: <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">Componente aggiuntivo del browser per la disattivazione</a></li>
                    <li>Your Online Choices: <a href="https://www.youronlinechoices.com/it/le-tue-scelte" target="_blank" rel="noopener noreferrer">Gestione cookie di profilazione</a></li>
                  </ul>
                </li>
              </ul>
              <p>
                La disattivazione dei cookie tecnici può compromettere il funzionamento del sito. 
                La disattivazione dei cookie analitici e di marketing non influisce sulla navigazione.
              </p>

              <h3>4. Cookie di Terze Parti</h3>
              <p>
                Alcuni cookie presenti sul nostro sito sono gestiti da terze parti. Per maggiori informazioni 
                sulle modalità di trattamento dei dati da parte di queste terze parti, si rimanda alle rispettive 
                informative sulla privacy:
              </p>
              <ul>
                <li><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google - Privacy Policy</a></li>
                <li><a href="https://www.facebook.com/policy.php" target="_blank" rel="noopener noreferrer">Meta Platforms - Privacy Policy</a></li>
              </ul>

              <h3>5. Aggiornamenti alla Cookie Policy</h3>
              <p>
                La presente Cookie Policy può essere aggiornata periodicamente per riflettere modifiche normative 
                o variazioni nei cookie utilizzati. Eventuali aggiornamenti saranno pubblicati su questa pagina 
                con indicazione della data di ultimo aggiornamento.
              </p>

              <h3>6. Contatti</h3>
              <p>Per qualsiasi domanda relativa alla presente Cookie Policy:</p>
              <ul>
                <li><strong>Email:</strong> privacy@rinovagroup.it</li>
                <li><strong>Indirizzo postale:</strong> Rinova Srl, Via Fratelli Bandiera 1, 88060 Montepaone (CZ), Italia</li>
              </ul>
              <p>
                Per informazioni complete sul trattamento dei dati personali, consultare la nostra{' '}
                <Link to="/privacy-policy" className="text-primary hover:underline">Informativa sulla Privacy</Link>.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;
